import React, { useEffect } from "react"

import { sendGoogleAnalyticsEvent } from "@modules/common/utils/analytics"

import SuccessScreen from "../../components/success"
import { StepProps } from "../step-registry"

const OrderCompletedSuccessfullyStep: React.FC<StepProps> = () => {
  useEffect(() => {
    sendGoogleAnalyticsEvent("ORDER_COMPLETED_SUCCESSFULLY")
  }, [])

  return <SuccessScreen />
}

export default OrderCompletedSuccessfullyStep
